import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

import mediaWidth from '../../../../../utils/mediaWidth/mediaWidth';
import { Font, FontWeight } from '../../../../../utils/fonts';
import Color from '../../../../../utils/colors';
import Links from '../../../../../utils/links';
import { directionsName } from '../../../../../utils/directionsData';
import screenData from '../../../../PhaserComponent/data/screenData';
import getScreenSize from '../../../../PhaserComponent/getSreenSize';

const open = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const close = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

class DesktopMenuContent extends Component {
    render() {
        const {
            className,
            isHidden,
            animation,
            onAnimationEnd,
            handleChangePage,
        } = this.props;

        const directions = {
            research: directionsName.RESEARCH,
            design: directionsName.DESIGN,
            launch: directionsName.LAUNCH,
            milestones: 'На каком вы этапе?',
            contacts: 'Контакты',
            team: 'Команда',
        };

        const directionsAliasLinks = {
            [directions.research]: Links.RESEARCH,
            [directions.design]: Links.DESIGN,
            [directions.launch]: Links.LAUNCH,
            [directions.milestones]: Links.MILESTONES,
            [directions.team]: Links.TEAM,
            [directions.contacts]: Links.CONTACTS,
        };

        return (
            <Root className={className} onAnimationEnd={onAnimationEnd}>
                <LinksWrapper>
                    {Object.keys(directions).map((key) => (
                        <LinkStyled
                            key={key.toString()}
                            isHidden={isHidden}
                            animation={animation}
                            onClick={() => handleChangePage(directionsAliasLinks[directions[key]])}
                        >
                            {directions[key]}
                        </LinkStyled>
                    ))}
                </LinksWrapper>
            </Root>
        );
    }
}

const Root = styled.div`
    position: fixed;
    top: 32px;
    /* right: 44px; */
    left: ${() => 2 * ((window.innerWidth - screenData[getScreenSize()].width) / 2) + 803}px;

    display: flex;
    cursor: pointer;

    ${mediaWidth.xl} {
        /* right: 80px; */
        left: ${() => 2 * ((window.innerWidth - screenData[getScreenSize()].width) / 2) + 1183}px;
    };
`;

const LinksWrapper = styled.div`
    display: flex;
    flex-direction: column;

    /* margin-left: 16px; */
    margin-top: 5px;
`;

const LinkStyled = styled.div`
    ${Font.HEADLINE};
    ${FontWeight.MEDIUM};
    font-size: 16px;
    line-height: 19px;
    color: #000000;
    text-decoration: none;
    text-transform: uppercase;

    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    margin-bottom: 4px;

    animation-name: ${({ animation }) => ((animation === 'open' && open) || (animation === 'close' && close) || 'unset')};
    animation-duration: 1s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;

    :hover {
        color: ${Color.SECONDARY};
    }

    &:nth-last-child(2) {
        margin-top: 16px;
    }
  
    &:last-child {
        margin-top: 0;
    }
`;

export default DesktopMenuContent;
